var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 14.1818C8.72727 14.1818 6 11.9091 6 10.0909C6 8.27273 8.72727 6 11 6C13.2727 6 16 8.27273 16 10.0909C16 11.9091 13.2727 14.1818 11 14.1818ZM11 7.81818C10.3972 7.81818 9.81916 8.05763 9.39294 8.48385C8.96672 8.91007 8.72727 9.48814 8.72727 10.0909C8.72727 10.6937 8.96672 11.2718 9.39294 11.698C9.81916 12.1242 10.3972 12.3636 11 12.3636C11.6028 12.3636 12.1808 12.1242 12.6071 11.698C13.0333 11.2718 13.2727 10.6937 13.2727 10.0909C13.2727 9.48814 13.0333 8.91007 12.6071 8.48385C12.1808 8.05763 11.6028 7.81818 11 7.81818Z",
    stroke: "#808086",
    strokeWidth: 1.09921
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.055c43ae6eb49fa6a67c88939fbdc5ad.svg";
export { ForwardRef as ReactComponent };